import styled from 'styled-components';

export const StyledFormRow = styled.div`
   display: grid;
   width: 100%;
   grid-template-columns: minmax(0px, 1fr) minmax(0, 1fr);
   gap: 32px;
`;
StyledFormRow.displayName = 'StyledFormRow';
